import React, { useState } from 'react';
import { Modal } from 'antd';
import styles from './CancelSubscriptionModal.module.scss';

const CancelSubscriptionModal = ({ visible, onClose, onConfirm }) => {
    const [selectedReason, setSelectedReason] = useState('');
    const [feedback, setFeedback] = useState('');

    const reasons = [
        'Too expensive',
        'Not using it enough',
        'Found a better alternative',
        'Technical issues',
        'Other'
    ];

    const handleCancel = () => {
        setSelectedReason('');
        setFeedback('');
        onClose();
    };

    const handleConfirm = () => {
        onConfirm({ reason: selectedReason, feedback });
        setSelectedReason('');
        setFeedback('');
    };

    return (
        <Modal
            open={visible}
            onCancel={handleCancel}
            footer={null}
            centered
            width={700}
            className={styles.cancelModal}
        >
            <div className={styles.modalContent}>
                {/* Header */}
                <div className={styles.header}>
                    <svg className={styles.warningIcon} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="20" fill="#FEF3F2" />
                        <path d="M24 16V24M24 32H24.02" stroke="#F04438" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h2 className={styles.title}>Cancel Subscription?</h2>
                    <p className={styles.subtitle}>We're sorry to see you go. Before you leave, help us understand why.</p>
                </div>

                {/* Reasons */}
                <div className={styles.reasonsSection}>
                    <label className={styles.sectionLabel}>Why are you canceling?</label>
                    <div className={styles.reasonsList}>
                        {reasons.map((reason) => (
                            <div
                                key={reason}
                                className={`${styles.reasonItem} ${selectedReason === reason ? styles.selected : ''}`}
                                onClick={() => setSelectedReason(reason)}
                            >
                                <div className={styles.radioButton}>
                                    {selectedReason === reason && <div className={styles.radioInner} />}
                                </div>
                                <span className={styles.reasonText}>{reason}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Feedback */}
                <div className={styles.feedbackSection}>
                    <label className={styles.sectionLabel}>Additional feedback (optional)</label>
                    <textarea
                        className={styles.feedbackInput}
                        placeholder="Tell us more about your experience..."
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        rows={4}
                    />
                </div>

                {/* Info Box */}
                <div className={styles.infoBox}>
                    <svg className={styles.infoIcon} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" stroke="#220ec9" strokeWidth="1.5" />
                        <path d="M10 9V13M10 7V7.5" stroke="#220ec9" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                    <div className={styles.infoText}>
                        <strong>Your access will continue until the end of your billing period.</strong>
                        <span>You can reactivate your subscription anytime before it expires.</span>
                    </div>
                </div>

                {/* Actions */}
                <div className={styles.actions}>
                    <button className={styles.keepButton} onClick={handleCancel}>
                        Keep Subscription
                    </button>
                    <button
                        className={styles.cancelButton}
                        onClick={handleConfirm}
                        disabled={!selectedReason}
                    >
                        Confirm Cancellation
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CancelSubscriptionModal;
